import { dateToJalali } from "../../../../../Utils/Helpers";

const SearchResult = ({
  context,
  loading,
  setType,
  type,
  setTeam,
  setLeague,
  addToTeam,
  addUserToList,
  addToLeague,
}) => {
  return (
    <>
      {context?.user?.name !== undefined && !loading ? (
        <>
          <div className='col-12'>
            <div className='d-flex flex-row my-4 border-bottom border-dark'>
              <h1 className='text-dark f-14 font-weight-bold'>
                مشخصات شرکت کننده
              </h1>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>نام و نام خانوادگی : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.name} {context?.user?.last_name}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>نام پدر : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.father_name}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>کدملی : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.national_card_id}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>شماره همراه : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.mobile}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>استان محل زندگی: </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.province_living?.name}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>تاریخ تولد : </span>
              <span className='text-dark f-14 mx-2'>
                {dateToJalali(context?.user?.birthday)}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-3 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'>تاریخ اتمام بیمه : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.insurance?.end_date}
              </span>
            </div>
          </div>
          <div className='col-12 col-md-6 my-3'>
            <div className='d-flex flex-row align-items-center'>
              <span className='text-dark f-14 mx-2'> آدرس : </span>
              <span className='text-dark f-14 mx-2'>
                {context?.user?.address}
              </span>
            </div>
          </div>
          <div className='col-12 my-3'>
            <div className='d-flex flex-row align-items-center justify-content-end'>
              <div className='form-group'>
                <label className='text-dark f-13 d-flex flex-row justify-content-start'>
                  نوع عملیات
                </label>
                <select
                  className='form-control'
                  name='type'
                  formikOnChange={false}
                  onChange={(e) => {
                    setType(e?.target?.value);
                  }}
                >
                  <option selected={true} disabled={true}>
                    انتخاب کنید
                  </option>
                  {context?.competition?.type?.find(
                    (t) => t.title === "انفرادی",
                  ) !== undefined && (
                    <option
                      disabled={
                        context?.competition?.type?.find(
                          (t) => t.title === "انفرادی",
                        ) !== undefined
                          ? false
                          : true
                      }
                      value='1'
                    >
                      افزودن به انفرادی
                    </option>
                  )}
                  {context?.competition?.type?.find(
                    (t) => t.title === "تیمی",
                  ) !== undefined && (
                    <option
                      disabled={
                        context?.competition?.type?.find(
                          (t) => t.title === "تیمی",
                        ) !== undefined
                          ? false
                          : true
                      }
                      value='2'
                    >
                      افزودن به تیم
                    </option>
                  )}
                  {context?.competition?.type?.find(
                    (t) => t.title === "لیگ",
                  ) !== undefined && (
                    <option
                      disabled={
                        context?.competition?.type?.find(
                          (t) => t.title === "لیگ",
                        ) !== undefined
                          ? false
                          : true
                      }
                      value='3'
                    >
                      افزودن به لیگ
                    </option>
                  )}
                </select>
              </div>
              {type == 2 || type == 3 ? (
                <div className='form-group'>
                  <label className='text-dark f-13 d-flex flex-row justify-content-start'>
                    انتخاب تیم
                  </label>
                  <select
                    className='form-control mx-2'
                    name='type'
                    formikOnChange={false}
                    onChange={(e) => {
                      type == 2
                        ? setTeam(e?.target?.value)
                        : setLeague(e?.target?.value);
                    }}
                  >
                    <option readOnly={true}>تیم را انتخاب کنید</option>
                    {type == 2 ? (
                      <>
                        {context?.teams?.map((team) => (
                          <option value={team?.id}>{team?.name}</option>
                        ))}
                      </>
                    ) : (
                      <>
                        {context?.leagues?.map((league) => (
                          <option value={league?.id}>{league?.name}</option>
                        ))}
                      </>
                    )}
                  </select>
                </div>
              ) : null}

              <div className='form-group mx-2 mt-4'>
                <button
                  onClick={
                    type == 1
                      ? addUserToList
                      : type == 2
                      ? addToTeam
                      : addToLeague
                  }
                  className='btn btn-info text-white f-13 mx-2 mt-1'
                >
                  افزودن کاربر
                </button>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default SearchResult;
